<template>
  <!-- 20190628新增div-->
  <div class="sc-chat-window-wrapper">
    <div class="sc-chat-window" :class="{ opened: isOpen, closed: !isOpen }">
      <Header v-show="waitShow" :title="title" :imageUrl="titleImageUrl" :onClose="onClose" :onMinify="onMinify"
        :isHistoryMode="isHistoryMode" :projectTitleName="projectTitleName" :Onboarding_action="Onboarding_action"
        :projectId="projectId" :isMobile="isMobile" :isApp="isApp" @showOnboarding="showOnboarding"
        @userList="handleUserListToggle" @show-input-bar="showInputBar" />
      <UserList v-if="showUserList" v-show="waitShow" :participants="participants" />
      <bulletin 
        :hide="hideBulletinValue"
        :announcements="announcements" 
        @hideBulletin="hideBulletin" >

      </bulletin>
      <Moneyudn v-if="gameNumber !== 0" class="iframeMoney" @close-game-popup="closeGamePopup" />
      <history-bar v-if="showHistoryBar" :is-show-history-mode="isHistoryMode" @show-input-bar="showInputBar" />
      <MessageList v-if="!showUserList" ref="messageListRef" :messages="messages" :participants="participants"
        :showTypingIndicator="showTypingIndicator" :show_noconnection="show_noconnection"
        :Onboarding_action="Onboarding_action" :alwaysScrollToBottom="alwaysScrollToBottom"
        :messageStyling="messageStyling" :projectId="projectId" :isMobile="isMobile" :isApp="isApp"
        :returnJSONtoMobile="returnJSONtoMobile" @tag-clicked="tagClicked"
        @show-to-bottom-callback="showToBottomCallback" v-show="waitShow && !showWelcome && gameNumber === 0" />
      <!-- && !showWelcome -->

      <!-- :colors="colors" -->
      <UserInput v-if="!showUserList" v-show="waitShow && !isHistoryMode && gameNumber === 0" :showEmoji="showEmoji"
        :onSubmit="onUserInputSubmit" :suggestions="getSuggestions()" :showFile="showFile" :placeholder="placeholder"
        :streamingIn="streamingIn" />
      <!-- :colors="colors" -->

      <!-- welcome page start -->
      <Welcome :titleImageUrl="titleImageUrl" :welcome_title="welcome_title" :welcome_subtitle="welcome_subtitle"
        :welcome_content="welcome_content" :welcomBg="welcomBg" :immediacy_time="immediacy_time"
        :projectTitleName="projectTitleName" :showWelcome="showWelcome" :show_activebtnPage="show_activebtnPage"
        :show_noconnection="show_noconnection" @showOnboarding="showOnboarding"
        @handle_show-welcome="handle_showWelcome" :handle_show_noconnection="handle_show_noconnection"
        :onClose="onClose" :onMinify="onMinify" :handle_logoutTimer="handle_logoutTimer" :isApp="isApp"
        :isMobile="isMobile" :device="device" :latData="latData" />

      <!-- Activebtn page start -->
      <Activebtn :show_activebtnPage="show_activebtnPage" :handle_show_activebtnPage="handle_show_activebtnPage" />

      <!-- Noconnection page start -->
      <Noconnection :show_noconnection="show_noconnection" :projectTitleName="projectTitleName"
        :noconnectionImageUrl="noconnectionImageUrl" :noconnection_icon_refresh="noconnection_icon_refresh"
        :noconnectionType="noconnectionType" :onClose="onClose" :onMinify="onMinify"
        :noconnection_closeModal="noconnection_closeModal" />

      <!-- onboarding page start -->
      <Onboarding :Onboarding_action="Onboarding_action" :closeOnboarding="closeOnboarding" />

      <div v-show="startToBottom" :class="{ 'toBottomIconRev': !showToBottom }" class="toBottomIcon"
        @click="toBottomEvent()">
        <img src="@/assets/btn_to_bottom.png" style="border-radius: inherit;" />
      </div>
    </div>

  </div>
</template>

<script>
import $ from "jquery"
import { collapsible } from "./js/collapsible.js"
import { refresh_btn } from "./js/refresh_btn.js"
import Header from "./Header.vue"
import MessageList from "./MessageList.vue"
import UserInput from "./UserInput.vue"
import UserList from "./UserList.vue"
import Welcome from "./Welcome.vue"
import Onboarding from "./Onboarding.vue"
import Activebtn from "./Activebtn.vue"
import Noconnection from "./Noconnection.vue"
import { mobileClose } from "../../pages/js/mobileClose.js"
import { mobileOnboarding } from "./js/mobileOnboarding.js"
import HistoryBar from "./HistoryBar.vue"
import Bulletin from "./Bulletin.vue"
import Moneyudn from './Moneyudn'
export default {
  components: {
    Header,
    MessageList,
    UserInput,
    UserList,
    Welcome,
    Onboarding,
    Activebtn,
    Noconnection,
    HistoryBar,
    Bulletin,
        Moneyudn
  },
  props: {
    gameNumber: {
      type: Number,
      default: 0
    },
    announcements: {
      type: Array,
      default: []
    },
    isHistoryMode: {
      type: Boolean,
      default: false
    },
    showEmoji: {
      type: Boolean,
      default: false
    },
    showHistoryBar: {
      type: Boolean,
      default: false
    },
    showHistoryMode: {
      type: Function,
      required: true
    },
    handle_logoutTimer: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleImageUrl: {
      type: String,
      default: ""
    },
    noconnectionType: {
      type: String,
      required: false,
      default: "network"
    },
    noconnectionImageUrl: {
      type: String,
      default: ""
    },
    noconnection_icon_refresh: {
      type: String,
      default: ""
    },
    welcomBg: {
      type: String,
      default: ""
    },
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    onMinify: {
      type: Function,
      required: true
    },
    returnJSONtoMobile: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: () => false
    },
    showWelcome: {
      type: Boolean,
      default: () => false
    },
    show_activebtnPage: {
      type: Boolean,
      default: () => false
    },
    handle_show_activebtnPage: {
      type: Function,
      required: true
    },
    show_noconnection: {
      type: Boolean,
      default: () => false
    },
    handle_show_noconnection: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: "請輸入文字(限50字) ..."
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    // colors: {
    //   type: Object,
    //   required: true
    // },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: String,
      default: () => ""
    },
    projectTitleName: {
      type: String,
      default: () => ""
    },
    isApp: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: () => ""
    },
    appModule_conversation_id: {
      type: String,
      default: () => ""
    },
    latData: {
      type: String,
      default: () => ""
    },
    streamingIn: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      showIframe: false,
      hideBulletinValue: true,
      showUserList: false,
      Onboarding_action: false,
      welcome_title: "",
      welcome_subtitle: "",
      welcome_content: "",
      immediacy_time: 0,
      waitShow: false,
      showToBottom: false,
      startToBottom: false
      // isShowHistoryMode: false
    }
  },
  async mounted() {
    collapsible()
    this.getApi()
    // 20200115 測試 APP 模組
    if (this.appModule_conversation_id !== "") {
      this.handle_showWelcome()
    }
    setTimeout(() => {
      this.waitShow = true
      this.startToBottom = true

    }, 1000)


    window.mobileOnboarding_ = this.mobileOnboarding_
  },
  computed: {
    messages() {
      let messages = this.messageList
      return messages
    }
  },
  methods: {
    closeGamePopup() {
      this.$emit('close-game-popup')
    },
    showBulletin() {
      this.hideBulletinValue = this.announcements.length === 0
    },
    hideBulletin() {
      this.hideBulletinValue = true
    },
    toBottomEvent() {
      // this.showToBottom = false
      this.$refs.messageListRef._scrollDown()

    },
    showToBottomCallback(show) {
      this.showToBottom = show
    },
    showInputBar(value) {
      // this.isShowHistoryMode = value
      this.showHistoryMode(value)
    },
    showOnboarding() {
      this.Onboarding_action = true
      this.mobileOnboarding_(this.device, true, "1")
    },
    closeOnboarding() {
      this.Onboarding_action = false
      this.mobileOnboarding_(this.device, false, "1")
    },
    mobileOnboarding_(device, status, action) {
      if (device == "android") {
        this.Onboarding_action = status
        if (action == "1") {
          try {
            // 若是 false 直接在 app 改變狀態，不從 web 再呼叫過來了
            window.AndroidWebView.mobileOnboarding(status)
          } catch (error) {
            // console.log(error)
          }
        } else if (action == "2") {
          // 呼叫回 APP 改變狀態 -> 或者 直接在 APP 內改變狀態即可
          // window.AndroidWebView.mobileOnboarding(status)
        }
      } else {
        // window.webkit.messageHandlers.botclosed.postMessage("")
      }
    },
    tagClicked(value) {
      this.$emit("tag-clicked", value)
    },
    handleUserListToggle(showUserList) {
      this.showUserList = showUserList
    },
    getSuggestions() {
      return this.messages.length > 0
        ? this.messages[this.messages.length - 1].suggestions
        : []
    },
    handle_showWelcome() {
      // click '開始吧' callback
      this.showBulletin()
      this.$emit("handle_show-welcome")
    },
    noconnection_closeModal() {
      // 檢查網路狀態
      refresh_btn(true)
      this.getApi()
    },
    // 取得 welcome 頁面資訊
    getApi() {
      const params = {
        // project_id: 'jinfm'
        project_id: this.projectId
      }
      this.axios
        .get(
          // `https://ccbot-test.udn-device-dept.net/public/${this.projectId}/chats/welcome`,
          `${process.env.BASE_API}/${this.projectId}/chats/welcome`,
          {
            params
          }
        )
        .then(response => {
          this.welcome_title = response.data.welcome_title
          this.welcome_subtitle = response.data.welcome_subtitle
          this.welcome_content = response.data.welcome_content
          // 設定 Timeout 時間
          this.immediacy_time = parseInt(response.data.immediacy_time)
          if (this.appModule_conversation_id !== "") {
            this.handle_logoutTimer(this.immediacy_time, true)
          } else {
            // reset 資料
            this.handle_show_noconnection(false, "defalut")
          }
          // 有網路時關閉離線畫面
          refresh_btn(false)
        })
        .catch(err => {
          console.log(err)
          // 無網路時顯示離線畫面
          this.handle_show_noconnection(true, "defalut")
          this.$message({
            type: "success",
            message: "請檢查網路狀態",
            duration: 3 * 1000
          })

          sessionStorage.setItem("immediacy_time", "undefine")
          sessionStorage.removeItem("conversation_id")
          this.messageList = []
          clearInterval(this.logoutTimer)
          this.logoutTimer = null

          clearInterval(this.timer)
          this.timer = null
        })
    }
  }
}
</script>
<style scoped>
@import "./styles/chatWindow.css";
@import "./styles/onboarding.css";

.toBottomIcon {
  display: block;
  position: absolute;
  opacity: 1;
  right: 36px;
  bottom: 96px;
  width: 32px;
  height: 32px;
  animation-name: up;
  animation-duration: 0.5s;


}

.toBottomIcon img {
  width: 32px;
  height: 32px;
  filter: drop-shadow(0px 3px 12px 0px rgba(15, 1, 62, 0.0887));
  /* box-shadow: 0px 3px 12px 0px rgba(15, 1, 62, 0.0887); */

}

.toBottomIconRev {
  opacity: 0;
  animation-name: down;
  animation-duration: 0.5s;
}

@keyframes down {
  0% {
    opacity: 1;
    bottom: 96px
  }

  100% {
    opacity: 0;
    bottom: 80px;
  }
}

@keyframes up {
  0% {
    opacity: 0;
    bottom: 80px;
  }

  100% {
    opacity: 1;
    bottom: 96px
  }
}

@keyframes dv-down {
  0% {
    opacity: 1;
    bottom: 72px
  }

  100% {
    opacity: 0;
    bottom: 64px;
  }
}

@keyframes dv-up {
  0% {
    opacity: 0;
    bottom: 64px;
  }

  100% {
    opacity: 1;
    bottom: 72px
  }
}

/* @media (max-width: 360px) { */
/* 20190905修改 */
@media screen and (max-device-width: 450px) {
  .toBottomIcon {
    display: block;
    position: absolute;
    opacity: 1;
    right: 12px;
    bottom: 72px;
    width: 32px;
    height: 32px;
    animation-name: dv-up;
    animation-duration: 0.5s;
  }
  .toBottomIconRev {
    opacity: 0;
    animation-name: dv-down;
    animation-duration: 0.5s;
  }

}
.iframeMoney {

}
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/ChatWindow.vue